var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":""}},'v-btn',attrs,false),on),[_c('v-icon',{staticClass:"mr-1 white--text"},[_vm._v(" mdi-account-circle ")]),_c('span',{staticClass:"user-name"},[_vm._t("username")],2),_c('v-icon',{staticClass:"ml-1 white--text"},[_vm._v(" mdi-chevron-down ")])],1)]}}],null,true)},[_c('v-list',[_vm._t("items")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }